webpackJsonp([15],{

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(491)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(494),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fff24ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userService__ = __webpack_require__(46);



// Get access token
var getToken = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(googleCode) {
    var res, accessToken, _refreshToken, user;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(apiUrl + "/api-token-auth/", {
              access_token: googleCode
            });

          case 3:
            res = _context.sent;

            if (!(res && res.data)) {
              _context.next = 16;
              break;
            }

            console.log("USER IS LOGGED");
            accessToken = res.data.access_token;
            _refreshToken = res.data.refresh_token;

            if (!accessToken) {
              _context.next = 14;
              break;
            }

            console.log("added acc token to headers");
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
            _context.next = 13;
            return __WEBPACK_IMPORTED_MODULE_3__userService__["a" /* userService */].getUser();

          case 13:
            user = _context.sent;

          case 14:
            if (_refreshToken) window.localStorage.setItem("engrefresh", _refreshToken);
            return _context.abrupt("return", res.data);

          case 16:
            _context.next = 22;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);

            console.log(_context.t0);
            return _context.abrupt("return", null);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 18]]);
  }));

  return function getToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fixCSRFToken = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            console.log("Testing CSRF token..");
            // Use a simple health check endpoint instead
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(apiUrl + "/health_check");

          case 4:
            res = _context2.sent;
            _context2.next = 10;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

            if (_context2.t0.response) {
              if (_context2.t0.response.status == 403) {
                console.log("Token failed.");
                delete_cookie("csrftoken_dev", "/", ".dev.app.morielenglish.co.il");
                delete_cookie("sessionid", "/", ".dev.app.morielenglish.co.il");
              }
            }

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[0, 7]]);
  }));

  return function fixCSRFToken() {
    return _ref2.apply(this, arguments);
  };
}();

// Get token from refresh
var refreshToken = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(refreshToken) {
    var res, accessToken, user;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(apiUrl + "/api-token-refresh/", {
              refresh: refreshToken
            });

          case 3:
            res = _context3.sent;

            if (!(res && res.data)) {
              _context3.next = 12;
              break;
            }

            accessToken = res.data.access;

            if (!accessToken) {
              _context3.next = 11;
              break;
            }

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

            _context3.next = 10;
            return __WEBPACK_IMPORTED_MODULE_3__userService__["a" /* userService */].getUser();

          case 10:
            user = _context3.sent;

          case 11:
            return _context3.abrupt("return", res.data);

          case 12:
            _context3.next = 18;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](0);

            console.log(_context3.t0);
            if (_context3.t0.response) {
              if (_context3.t0.response.status == 401 || _context3.t0.response.status == 403) {
                window.localStorage.removeItem("engrefresh");
              }
            }
            // location.reload()

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[0, 14]]);
  }));

  return function refreshToken(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

// Handle authentication callback with tokens from URL


// Check current authentication state
var checkAuthState = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    var refreshTokenFromStorage, result;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            refreshTokenFromStorage = window.localStorage.getItem("engrefresh");

            if (!refreshTokenFromStorage) {
              _context4.next = 24;
              break;
            }

            console.log("Auth state: Found refresh token, attempting to refresh access token");
            _context4.prev = 3;
            _context4.next = 6;
            return refreshToken(refreshTokenFromStorage);

          case 6:
            result = _context4.sent;

            if (!(result && result.access)) {
              _context4.next = 12;
              break;
            }

            console.log("Auth state: Successfully refreshed tokens");
            return _context4.abrupt("return", { authenticated: true });

          case 12:
            console.log("Auth state: Failed to refresh tokens");
            window.localStorage.removeItem("engrefresh");
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
            return _context4.abrupt("return", { authenticated: false });

          case 16:
            _context4.next = 24;
            break;

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](3);

            console.error("Auth state: Error refreshing tokens:", _context4.t0);
            window.localStorage.removeItem("engrefresh");
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
            return _context4.abrupt("return", { authenticated: false });

          case 24:

            console.log("Auth state: No refresh token found");
            return _context4.abrupt("return", { authenticated: false });

          case 26:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[3, 18]]);
  }));

  return function checkAuthState() {
    return _ref4.apply(this, arguments);
  };
}();

var apiUrl = "https://api.dev.app.morielenglish.co.il";
var googleLogin = apiUrl + "/google-direct/";
var googleClientID = "887990840804-eshjuu4g4glg3ufuf6p0ho40c0s1pnrt.apps.googleusercontent.com";

var authService = {
  refreshToken: refreshToken,
  getToken: getToken,
  logout: logout,
  fixCSRFToken: fixCSRFToken,
  googleLogin: googleLogin,
  googleClientID: googleClientID,
  handleAuthCallback: handleAuthCallback,
  checkAuthState: checkAuthState
};




__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.xsrfCookieName = "csrftoken_dev";
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.xsrfHeaderName = "X-CSRFToken";
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withXSRFToken = true;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;

function logout() {
  var logoutUrl = apiUrl + "/accounts/logout/";
  window.location.href = logoutUrl;
}

function delete_cookie(name, path, domain) {
  if (get_cookie(name)) {
    document.cookie = name + "=" + (path ? ";path=" + path : "") + (domain ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
  }
}

function get_cookie(name) {
  return document.cookie.split(';').some(function (c) {
    return c.trim().startsWith(name + '=');
  });
}function handleAuthCallback() {
  var urlParams = new URLSearchParams(window.location.search);
  var accessToken = urlParams.get('access_token');
  var refreshToken = urlParams.get('refresh_token');
  var error = urlParams.get('error');

  if (error) {
    console.error('Auth callback error:', error);
    // Clear any existing tokens
    window.localStorage.removeItem("engrefresh");
    delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"];
    return { success: false, error: error };
  }

  if (accessToken && refreshToken) {
    console.log("Auth callback: Found tokens in URL");
    console.log("Auth callback: Access token (first 20 chars):", accessToken.substring(0, 20));
    console.log("Auth callback: Refresh token (first 20 chars):", refreshToken.substring(0, 20));

    // Store tokens
    window.localStorage.setItem("engrefresh", refreshToken);
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

    console.log("Auth callback: Stored refresh token in localStorage");
    console.log("Auth callback: Set Authorization header");
    console.log("Auth callback: localStorage now contains:", localStorage.getItem("engrefresh") ? "refresh token" : "no refresh token");

    // Clean URL
    var url = new URL(window.location);
    url.searchParams.delete('access_token');
    url.searchParams.delete('refresh_token');
    window.history.replaceState({}, document.title, url.toString());

    console.log("Auth callback: Tokens stored successfully");
    return { success: true, accessToken: accessToken, refreshToken: refreshToken };
  }

  return { success: false, message: 'No tokens found' };
}

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_authService__ = __webpack_require__(241);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GoogleButton",
  methods: {
    redirect: function redirect() {
      window.location.href = "" + __WEBPACK_IMPORTED_MODULE_0__services_authService__["a" /* authService */].googleLogin;
    }
  }
});

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('button', {
    staticClass: "fullBtn",
    on: {
      "click": function($event) {
        return _vm.redirect()
      }
    }
  }, [_c('inline-svg', {
    staticClass: "googleIcon",
    attrs: {
      "src": __webpack_require__(212).default
    }
  }), _vm._v("\n    " + _vm._s(_vm.$t("user.loginButton.button")) + "\n  ")], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(272);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("c47d271c", content, true, {});

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".welcome{padding:32px 22px;position:absolute;inset:0;display:flex;flex-direction:column;gap:24px}.welcome h2{font:var(--huge-font);margin-top:20px}.welcome h3{font:var(--huge-font);text-align:center}.welcome .textbox{color:#19181e;font-size:20px}.welcome svg{overflow:visible}.welcome .lockbreak{width:30px}.welcome .register-text{font-size:24px;margin-bottom:20px;text-align:center}.welcome .package-details{font-size:20px}.welcome .subtitle{font-size:26px;margin-bottom:24px}.welcome .icon{width:30px;padding-bottom:10px}.welcome .line{display:flex;margin:10px 20px;align-items:center;gap:10px}.welcome .program-option{height:fit-content;border:1px solid #000;border-radius:5px;display:flex;align-items:center;justify-content:space-between;margin:10px 0;padding:16px 28px}.welcome .bestOption{position:relative;padding-top:20px}.welcome .chosenOption{background-color:#555fff;color:#fff;outline:3px solid #119}.welcome span{font:var(--medium-font)}.welcome .recomanded{background-color:#119;color:#fff;font:var(--tiny-font);position:absolute;top:0;right:0px;border-bottom-left-radius:11px;padding:0px 5px}.welcome .takanon{width:100%;background-color:#fff;border:#a6a6d9 1px solid;height:100px;overflow:scroll;margin:5px auto;padding:3px}.welcome .takanon p{font:var(--small-font)}.welcome .confirm{background-color:var(--bg-primary);border:#a6a6d9 1px solid;height:100px;overflow:scroll;border-radius:5px;margin:70px auto 10px;padding:8px}.welcome .confirm p{font:var(--small-font)}.welcome .submit-payment{display:flex;justify-content:center}.welcome .submit-payment button{width:100%;height:58px;border-radius:5px;background-color:var(--button-primary);color:var(--button-primary-text);margin:auto;font:var(--large-font)}.welcome .takanon-text{font:var(--small-font)}.modal-container{position:fixed;z-index:1000;width:100%;left:0;top:0;background-color:rgba(0,0,0,.4);height:100%}.modal-content{background:var(--bg-primary);height:fit-content;text-align:center;padding:5%;border-radius:5px}.fullBtn{color:var(--button-primary-text);font:var(--medium-font);width:100%;border-radius:8px;background-color:var(--button-primary);height:60px;display:flex;justify-content:center;align-items:center;gap:8px}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/style.scss"],"names":[],"mappings":"AAAA,SACE,kBACA,kBACA,QACA,aACA,sBACA,QAAA,CAEA,YACE,sBACA,eAAA,CAGF,YACE,sBACA,iBAAA,CAGF,kBACE,cACA,cAAA,CAGF,aACE,gBAAA,CAGF,oBACE,UAAA,CAGF,wBACE,eACA,mBACA,iBAAA,CAGF,0BACE,cAAA,CAGF,mBACE,eACA,kBAAA,CAGF,eACE,WACA,mBAAA,CAGF,eACE,aACA,iBACA,mBACA,QAAA,CAGF,yBACE,mBACA,sBAEA,kBACA,aACA,mBACA,8BACA,cACA,iBAAA,CAGF,qBACE,kBACA,gBAAA,CAGF,uBACE,yBACA,WACA,sBAAA,CAGF,cACE,uBAAA,CAGF,qBACE,sBACA,WACA,sBACA,kBACA,MACA,UACA,+BACA,eAAA,CAGF,kBACE,WACA,sBACA,yBACA,aACA,gBACA,gBACA,WAAA,CAEA,oBACE,sBAAA,CAIJ,kBACE,mCACA,yBACA,aACA,gBACA,kBACA,sBACA,WAAA,CAEA,oBACE,sBAAA,CAIJ,yBACE,aACA,sBAAA,CAEA,gCACE,WACA,YACA,kBACA,uCAEA,iCACA,YACA,sBAAA,CAIJ,uBACE,sBAAA,CAIJ,iBACE,eACA,aACA,WACA,OACA,MACA,gCACA,WAAA,CAGF,eACE,6BACA,mBACA,kBACA,WACA,iBAAA,CAGF,SACE,iCACA,wBACA,WACA,kBACA,uCACA,YACA,aACA,uBACA,mBACA,OAAA,CAAA","file":"style.scss","sourcesContent":[".welcome {\n  padding: 32px 22px;\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  h2 {\n    font: var(--huge-font);\n    margin-top: 20px;\n  }\n\n  h3 {\n    font: var(--huge-font);\n    text-align: center;\n  }\n\n  .textbox {\n    color: #19181e;\n    font-size: 20px;\n  }\n\n  svg {\n    overflow: visible;\n  }\n\n  .lockbreak {\n    width: 30px;\n  }\n\n  .register-text {\n    font-size: 24px;\n    margin-bottom: 20px;\n    text-align: center;\n  }\n\n  .package-details {\n    font-size: 20px;\n  }\n\n  .subtitle {\n    font-size: 26px;\n    margin-bottom: 24px;\n  }\n\n  .icon {\n    width: 30px;\n    padding-bottom: 10px;\n  }\n\n  .line {\n    display: flex;\n    margin: 10px 20px;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .program-option {\n    height: fit-content;\n    border: 1px solid black;\n    // width: 100%;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 10px 0;\n    padding: 16px 28px;\n  }\n\n  .bestOption {\n    position: relative;\n    padding-top: 20px;\n  }\n\n  .chosenOption {\n    background-color: #555fff;\n    color: #fff;\n    outline: 3px solid #111199;\n  }\n\n  span {\n    font: var(--medium-font);\n  }\n\n  .recomanded {\n    background-color: #111199;\n    color: white;\n    font: var(--tiny-font);\n    position: absolute;\n    top: 0;\n    right: 0px;\n    border-bottom-left-radius: 11px;\n    padding: 0px 5px;\n  }\n\n  .takanon {\n    width: 100%;\n    background-color: white;\n    border: #a6a6d9 1px solid;\n    height: 100px;\n    overflow: scroll;\n    margin: 5px auto;\n    padding: 3px;\n\n    p {\n      font: var(--small-font);\n    }\n  }\n\n  .confirm {\n    background-color: var(--bg-primary);\n    border: #a6a6d9 1px solid;\n    height: 100px;\n    overflow: scroll;\n    border-radius: 5px;\n    margin: 70px auto 10px;\n    padding: 8px;\n\n    p {\n      font: var(--small-font);\n    }\n  }\n\n  .submit-payment {\n    display: flex;\n    justify-content: center;\n\n    button {\n      width: 100%;\n      height: 58px;\n      border-radius: 5px;\n      background-color: var(--button-primary);\n\n      color: var(--button-primary-text);\n      margin: auto;\n      font: var(--large-font);\n    }\n  }\n\n  .takanon-text {\n    font: var(--small-font);\n  }\n}\n\n.modal-container {\n  position: fixed;\n  z-index: 1000;\n  width: 100%;\n  left: 0;\n  top: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  height: 100%;\n}\n\n.modal-content {\n  background: var(--bg-primary);\n  height: fit-content;\n  text-align: center;\n  padding: 5%;\n  border-radius: 5px;\n}\n\n.fullBtn {\n  color: var(--button-primary-text);\n  font: var(--medium-font);\n  width: 100%;\n  border-radius: 8px;\n  background-color: var(--button-primary);\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(492);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("6b483adc", content, true, {});

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.footerLinks[data-v-2fff24ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-top: 0;\n  width: calc(100vw - 40px);\n  position: fixed;\n  bottom: 0;\n  height: -webkit-max-content;\n  height: -moz-max-content;\n  height: max-content;\n}\n.textbox[data-v-2fff24ae] {\n  font: var(--medium-font);\n  color: var(--color-primary-lt);\n  margin-top: 16px;\n}\n.button-container[data-v-2fff24ae] {\n  width: 100%;\n  margin-top: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.registratio-disclaimer-text[data-v-2fff24ae],\n.registratio-disclaimer-text span[data-v-2fff24ae] {\n  font: var(--tiny-font);\n  padding: 8px;\n  text-align: center;\n  color: var(--color-secondary-ltr);\n}\n.registratio-disclaimer-text span[data-v-2fff24ae] {\n  text-decoration: underline;\n  padding: 0;\n}\n.welcome[data-v-2fff24ae] {    display: -webkit-box;    display: -ms-flexbox;    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.register-text[data-v-2fff24ae]{margin-bottom:0;\n}\n.textbox[data-v-2fff24ae]{margin:0;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Welcome/welcome.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;CACrB;AACD;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;CAClB;AACD;EACE,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,yBAAyB;MACrB,sBAAsB;UAClB,wBAAwB;CACjC;AACD;;EAEE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;CACnC;AACD;EACE,2BAA2B;EAC3B,WAAW;CACZ;AACD,+BAA+B,qBAAqB,IAAI,qBAAqB,IAAI,cAAc;IAC3F,yBAAyB;QACrB,sBAAsB;YAClB,wBAAwB;CACnC;AACD,gCAAgC,gBAAgB;CAC/C;AACD,0BAA0B,SAAS;CAClC","file":"welcome.vue","sourcesContent":["\n.footerLinks[data-v-2fff24ae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  margin-top: 0;\n  width: calc(100vw - 40px);\n  position: fixed;\n  bottom: 0;\n  height: -webkit-max-content;\n  height: -moz-max-content;\n  height: max-content;\n}\n.textbox[data-v-2fff24ae] {\n  font: var(--medium-font);\n  color: var(--color-primary-lt);\n  margin-top: 16px;\n}\n.button-container[data-v-2fff24ae] {\n  width: 100%;\n  margin-top: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.registratio-disclaimer-text[data-v-2fff24ae],\n.registratio-disclaimer-text span[data-v-2fff24ae] {\n  font: var(--tiny-font);\n  padding: 8px;\n  text-align: center;\n  color: var(--color-secondary-ltr);\n}\n.registratio-disclaimer-text span[data-v-2fff24ae] {\n  text-decoration: underline;\n  padding: 0;\n}\n.welcome[data-v-2fff24ae] {    display: -webkit-box;    display: -ms-flexbox;    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.register-text[data-v-2fff24ae]{margin-bottom:0;\n}\n.textbox[data-v-2fff24ae]{margin:0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__User_googleButton_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__User_googleButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__User_googleButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_style_scss__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Shared_style_scss__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    goBack: function goBack() {
      this.$router.push('/');
    },
    navigate: function navigate(path) {
      this.$router.push("/" + path);
    },
    goToWA: function goToWA() {
      window.open("https://api.whatsapp.com/send?phone=972526252650&text=%D7%94%D7%99%D7%99!%20%F0%9F%98%83%0A%D7%90%D7%A0%D7%99%20%D7%A8%D7%9B%D7%A9%D7%AA%D7%99%20%D7%9E%D7%A0%D7%95%D7%99%20%D7%9C%D7%90%D7%A4%D7%9C%D7%99%D7%A7%D7%A6%D7%99%D7%94%20%D7%A9%D7%9C%D7%9A%20%D7%9B%D7%91%D7%A8%20%D7%95%D7%92%D7%9D%20%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A7%D7%91%D7%9C%D7%94%20%D7%90%D7%91%D7%9C%20%D7%96%D7%94%20%D7%93%D7%95%D7%A8%D7%A9%20%D7%9E%D7%9E%D7%A0%D7%99%20%D7%AA%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%AA%D7%95%D7%9B%D7%9C%20%D7%9C%D7%A2%D7%96%D7%95%D7%A8%20%D7%9C%D7%99%20%D7%9C%D7%A9%D7%97%D7%96%D7%A8%20%D7%90%D7%AA%20%D7%94%D7%9E%D7%A0%D7%95%D7%99%20%D7%A9%D7%9C%D7%99%3F%0A%D7%AA%D7%95%D7%93%D7%94", "_blank");
    }
  },
  components: {
    GoogleButton: __WEBPACK_IMPORTED_MODULE_0__User_googleButton_vue___default.a
  }
});

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome"
  }, [_c('div', {
    staticClass: "register-text"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(_vm.$t("welcome.header")) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "textbox",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('welcome.description'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('GoogleButton'), _vm._v(" "), _c('div', {
    staticClass: "registratio-disclaimer-text"
  }, [_vm._v("\n      ההרשמה למערכת מהווה אישור לקריאה והסכמה ל"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('terms')
      }
    }
  }, [_vm._v("תנאי השימוש")]), _vm._v(" ול"), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('privacy')
      }
    }
  }, [_vm._v("מדיניות הפרטיות")]), _vm._v(" שלנו.\n    ")])], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 15.ce03fd3d81a126f24b18.bundle.js